module.exports = __webpack_public_path__ + "static/media/diariodemallorca.b7d03c8f.png";